import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { photo_blue } from "../../../../constants/images";
import CollegeDetails from "./CollegeDetails";
import RepresentativeDetails from "./RepresentativeDetails";
import Documents from "./Documents";
import SignedData from "./SignedData";
import VirtualVerification from "./VirtualVerification";
import MainAction from "./MainAction";
import {
  GetCollegeReqDetails,
  GetRepresentativeDetails,
  ChangeStatus,
} from "../../../../services/collegeRequests";
import VerifyRejectReq from "./VerifyRejectRequest";
import toast from "react-hot-toast";

const ViewRequest = () => {
  let location = useLocation();
  const [type, setType] = useState("CollegeDetails");
  const [tab, setTab] = useState(
    location?.state?.tab ? location?.state?.tab : 0
  );
  const [data, setData] = useState({});
  const [basicData, setBasicData] = useState({
    profileImage: "",
    collegeName: "",
    collegeId: "",
    country: "",
    city: "",
    state: "",
    contactPerson: "",
    mobile: "",
    email: "",
    request_status: "0", // 0: pending, 1: approved
  });
  const [refresh, setRefresh] = useState(false);
  const [filterModalShow, setFilterModalShow] = useState(false);
  const [loading, setLoading] = useState(true);

  // Add ref to prevent double submission
  const isSubmittingRef = useRef(false);

  const { id } = useParams(); // Extract the ID from URL params
  const requestId = id; // Use this ID for the API call
  const navigate = useNavigate();

  const admin_type = localStorage.getItem("admin_type") || "";

  useEffect(() => {
    fetchRequestData();
  }, [requestId, refresh]);

  const fetchRequestData = async () => {
    try {
      setLoading(true);
      // Fetch real API data using the requestId from URL
      const response = await GetCollegeReqDetails(requestId);

      if (response && response.data.statusCode === 200) {
        const collegeData = response.data.result;

        // Update basic data for the card display
        setBasicData({
          profileImage: collegeData.clg_logo || "",
          collegeName: collegeData.clg_name || "NA",
          collegeId: collegeData.college_id || "NA",
          country: collegeData.country_name || "NA",
          city: collegeData.city || "NA",
          state: collegeData.state_name || "NA",
          contactPerson: collegeData.college_admin || "NA",
          mobile: `${collegeData.country_code || ""} ${
            collegeData.mobile_no || "NA"
          }`,
          email: collegeData.official_email || "NA",
          // request_status: "0",
          request_status: collegeData.request_status || "0",
        });

        // Set the full data for the selected tab component
        setData(collegeData);
      } else {
        console.error("Failed to fetch college request details");
      }
    } catch (error) {
      console.error("Error fetching college request details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (formData) => {
    // Prevent double submission using ref
    if (isSubmittingRef.current) {
      console.log("Already submitting, ignoring duplicate call");
      return;
    }

    try {
      isSubmittingRef.current = true;
      setLoading(true);

      console.log("Received form data:", formData); // Debug log

      const payload = {
        request_id: requestId,
        status:
          formData.status === "1"
            ? "approve"
            : formData.status === "2"
            ? "hold"
            : "reject",
        reason: formData.comment || "", // Use the comment from form
      };

      console.log("API Payload:", payload); // Debug log

      const response = await ChangeStatus(payload);

      if (response && response.data.statusCode === 200) {
        // Show success message
        toast.success("Status updated successfully");

        // Refresh data and close modal
        setRefresh((prev) => !prev);
        setFilterModalShow(false);
      } else {
        throw new Error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(error.message || "Failed to update status");
      // Don't close modal on error so user can retry
    } finally {
      setLoading(false);
      // Reset the ref after a short delay to allow for proper cleanup
      setTimeout(() => {
        isSubmittingRef.current = false;
      }, 1000);
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "1":
        return "Request Approved";
      case "2":
        return "Under Verification";
      case "3":
        return "Incomplete Profile";
      case "0":
      default:
        return "Take Action";
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "1":
        return "approved";
      case "2":
        return "pending";
      case "3":
        return "incomplete";
      case "0":
      default:
        return "";
    }
  };

  return (
    <div className="view-r-container">
      <div className="scholarship-detail">
        <div className="subheader-title">
          <h2 className="heading-36">View Request</h2>
          <div className="subheader-right-btm">
            <button
              className={`btn-purple ${getStatusClass(
                basicData?.request_status
              )}`}
              onClick={() => {
                if (basicData?.request_status !== "1") {
                  // Only allow action if not already approved
                  setFilterModalShow(true);
                }
              }}
              disabled={basicData?.request_status === "1"}
            >
              {getStatusText(basicData?.request_status)}
            </button>
          </div>
        </div>

        {/* User/College Data Section */}
        {loading ? (
          <div className="loading-indicator">Loading college data...</div>
        ) : (
          <div>
            <div className="user-data view-r-user-data">
              <div className="user-img">
                <img
                  src={basicData?.profileImage || photo_blue}
                  alt="College Logo"
                />
              </div>

              <div className="college-info-new">
                <div className="user"></div>
                <div className="user_detail">
                  <h4
                    className=""
                    style={{ color: "white" }}
                    title={basicData?.collegeName || "NA"}
                  >
                    {basicData?.collegeName && basicData.collegeName.length > 12
                      ? basicData.collegeName.substring(0, 12) + "..."
                      : basicData?.collegeName || "NA"}
                  </h4>
                  <p className="no_wrap">{basicData?.state || "NA"}</p>
                </div>
                <div className="user_detail">
                  <h5 className="no_wrap">College ID</h5>
                  <p className="no_wrap">{basicData?.collegeId || "NA"}</p>
                </div>
                <div className="user_detail">
                  <h5 className="no_wrap">Country</h5>
                  <p className="no_wrap">{basicData?.country || "NA"}</p>
                </div>
                <div className="user_detail">
                  <h5>City</h5>
                  <p className="">{basicData?.city || "NA"}</p>
                </div>
                <div className="user_detail">
                  <h5>Contact Person</h5>
                  <p className="no_wrap">{basicData?.contactPerson || "NA"}</p>
                </div>
                <div className="user_detail">
                  <h5>Mobile</h5>
                  <p className="no_wrap">{basicData?.mobile || "NA"}</p>
                </div>
                <div className="user_detail">
                  <h5>Email</h5>
                  <p className="">{basicData?.email || "NA"}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Navigation Tabs */}
        <div className="nav-tab view-r-nav-tab">
          <div
            className={`tabbing-button ${tab === 0 ? "active" : ""}`}
            onClick={() => {
              setTab(0);
              setType("CollegeDetails");
            }}
          >
            <button>College Details</button>
          </div>
          <div
            className={`tabbing-button ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
              setType("RepresentativeDetails");
            }}
          >
            <button>Representative Details</button>
          </div>
          <div
            className={`tabbing-button ${tab === 2 ? "active" : ""}`}
            onClick={() => {
              setTab(2);
              setType("Documents");
            }}
          >
            <button>Documents</button>
          </div>
          <div
            className={`tabbing-button ${tab === 3 ? "active" : ""}`}
            onClick={() => {
              setTab(3);
              setType("SignedData");
            }}
          >
            <button>Signed Data</button>
          </div>
          <div
            className={`tabbing-button ${tab === 4 ? "active" : ""}`}
            onClick={() => {
              setTab(4);
              setType = "VirtualVerification";
            }}
          >
            <button>Virtual Verification</button>
          </div>
        </div>

        {/* Tab Content */}
        {loading ? (
          <div className="tab-loading">Loading data...</div>
        ) : (
          <>
            {tab === 0 && (
              <CollegeDetails
                data={data}
                setTab={setTab}
                setType={setType}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            )}
            {tab === 1 && (
              <RepresentativeDetails
                data={data}
                setTab={setTab}
                setType={setType}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            )}
            {tab === 2 && (
              <Documents
                data={data}
                setTab={setTab}
                setType={setType}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            )}
            {tab === 3 && (
              <SignedData
                data={data}
                setTab={setTab}
                setType={setType}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            )}
            {tab === 4 && (
              <VirtualVerification
                data={data}
                setTab={setTab}
                setType={setType}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            )}
          </>
        )}
      </div>

      {/* Action Modal Component */}
      <VerifyRejectReq
        show={filterModalShow}
        onHide={() => setFilterModalShow(false)}
        setRefresh={setRefresh}
        refresh={refresh}
        moduleName={"College Request"}
        moduleType={"college"}
        onSubmit={handleStatusChange} // Pass the entire function, not destructured params
        currentStatus={basicData?.request_status}
        loading={loading} // Pass loading state to modal
      />
    </div>
  );
};

export default ViewRequest;
